<template>
  <Confirm :reg="reg"></Confirm>
</template>

<script>
export default {
  name: 'NewRegistrationConfirm',
  components: {
    Confirm: () => import('../../components/cloud/UserRegistration/Confirm.vue')
  },
  props: {
    reg: Object
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name === 'new-registration' && vm.reg.editState === 'edited'){
        next()
        return;
      }
      next({ name: 'new-registration' })
    })
  }
}
</script>

<style scoped>
</style>